import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { ICreateInformacoesEntregaObraClienteUseCase } from '../../../presentation/useCases/create/create_informacoes_entrega_obra_cliente_use_case';

/**
 * CreateInformacoesEntregaObraClienteUseCase
 */

export class CreateInformacoesEntregaObraClienteUseCase implements ICreateInformacoesEntregaObraClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObraCliente: number,
    idVerificacaoChecklist?: number,
    dataDescricao?: Date,
    dataTratativa?: Date,
    descricao?: string,
    tratativa?: string,
    inspecao?: number,

    descricaoArquivo?: string,
    arquivo?: File,
    descricaoArquivo2?: string,
    arquivo2?: File

  ): Promise<void> {
    const computedArquivo = arquivo ? arquivo : undefined;
    const nameArquivo = arquivo ? arquivo : null;

    const computedArquivo2 = arquivo2 ? arquivo2 : undefined;
    const nameArquivo2 = arquivo2 ? arquivo2 : null;

    await this.repository.createInformacoesEntregaObrasCliente(
      idEntregaObraCliente,
      idVerificacaoChecklist,
      dataDescricao,
      dataTratativa,
      descricao,
      tratativa,
      inspecao,

      descricaoArquivo,
      computedArquivo,
      nameArquivo ? nameArquivo.name : undefined,

      descricaoArquivo2,
      computedArquivo2,
      nameArquivo2 ? nameArquivo2.name : undefined


    );
  }
}
